<template>
  <div class="scss-click-effect">
    <div class="py-3 text-start d-flex flex-row" @click="goBack">
      <i
        class="pe-2 bi bi-chevron-left"
        style="-webkit-text-stroke: 1px #4a4a4a"
      />
      <span class="fw-bold">Back</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "BackButton",
  props: { goBackTo: String },
  methods: {
    goBack() {
      this.goBackTo
        ? this.$router.push(this.goBackTo.toString())
        : this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
.style-button-container {
  width: 100px;
}
</style>
